'use client'

import { Dialog, DialogTitle, DialogContent } from '@eversports/klimt-primitives/Dialog'
import { useTranslations } from 'next-intl'

interface Props {
  isOpen: boolean
  toggleCookieBanner: () => void
}

const CookieDialog = ({ children, isOpen, toggleCookieBanner }: React.PropsWithChildren<Props>) => {
  const t = useTranslations('cookies')
  return (
    <>
      <p onClick={toggleCookieBanner} className="cursor-pointer text-base text-slate-200 hover:underline">
        {t('footer-text')}
      </p>
      <Dialog open={isOpen}>
        <DialogContent>
          <DialogTitle className="m-1 text-center font-bold">{t('title')}</DialogTitle>
          {children}
        </DialogContent>
      </Dialog>
    </>
  )
}
export default CookieDialog
